module.exports = __webpack_public_path__ + "static/media/ploni-ultrabold-aaa.68f8ccc9.woff2";